import { paths } from '@/constants/paths';
import { useLocaleLink } from '@/ui/hooks/useLocaleLink';
import formatPunctuation from '@/ui/utils/formatPunctuation';
import { useTranslations } from 'next-intl';
import React from 'react';
import QRCode from 'react-qr-code';
import { twMerge } from 'tailwind-merge';

function QRCodeTip({ className }: { className?: string }) {
  const t = useTranslations('IC_Survey');
  const { localizedUrl } = useLocaleLink();

  return (
    <div
      className={twMerge(
        'mx-auto my-10 flex max-w-2xl items-center justify-center gap-5 rounded-lg bg-white  px-8 py-4 shadow-lg',
        className,
      )}
    >
      <div>
        <QRCode
          size={190}
          style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
          value={localizedUrl(paths.installationCheck)}
          viewBox="0 0 256 256"
        />
      </div>
      <div className="h-56 flex flex-col justify-between text-left">
        <p className="text-lg font-semibold">{formatPunctuation(t('Tip:'))}</p>
        <p className="mt-1">
          {t(
            'For the best possible user experience, we recommend you do the installation check on your smartphone right at your door',
          )}
        </p>
        <p className="mt-2">{t('To run it on your mobile device, simply scan this QR code')}</p>
      </div>
    </div>
  );
}

export default QRCodeTip;
